import "./MessageBubble.css";

interface MessageBubbleProps {
  role: "user" | "assistant" | "tool";
  content: string;
  onEdit?: () => void;
}

export default function MessageBubble({
  role,
  content,
  onEdit,
}: MessageBubbleProps) {
  return (
    <div className={`message-row ${role}`}>
      <div className={`message-bubble ${role}`}>
        <div
          className="message-content"
          dangerouslySetInnerHTML={{ __html: content }}
        />

        {role === "user" && onEdit && (
          <button className="edit-button" onClick={onEdit} title="Edit">
            ✏️
          </button>
        )}
      </div>
    </div>
  );
}
